export default {
    getMetaContent: function(name) {
        var metas = document.getElementsByTagName("meta");

        for (var i=0; i<metas.length; i++) {
            if (metas[i].getAttribute("name") == name) {
                return metas[i].getAttribute("content");
            }
        }

        return "";
    }
};



// WEBPACK FOOTER //
// ./src/util/functions.js